// Configuración centralizada de estados y colores para badges
// Basado en la paleta de colores especificada

export const SALE_STATUS_CONFIG = {
  // Azul (#ebf3ff / #002152)
  created: {
    backgroundColor: '#ebf3ff',
    color: '#002152',
    textColor: '#002152',
    label: 'Creada',
    class: 'badge-custom-created'
  },
  
  // Amarillo (#fff3cd / #856404)
  pending_docs: {
    backgroundColor: '#fff3cd',
    color: '#856404',
    textColor: '#856404',
    label: 'Pendiente de Documentación',
    class: 'badge-custom-pending-docs'
  },
  pending_verification: {
    backgroundColor: '#fff3cd',
    color: '#856404',
    textColor: '#856404',
    label: 'Pendiente de Verificación',
    class: 'badge-custom-pending-verification'
  },
  observed: {
    backgroundColor: '#fff3cd',
    color: '#856404',
    textColor: '#856404',
    label: 'Observada',
    class: 'badge-custom-observed'
  },
  
  // Verde (#d2ffe8 / #00391c)
  verified: {
    backgroundColor: '#d2ffe8',
    color: '#00391c',
    textColor: '#00391c',
    label: 'Verificada',
    class: 'badge-custom-verified'
  },
  liquidated: {
    backgroundColor: '#d2ffe8',
    color: '#00391c',
    textColor: '#00391c',
    label: 'Liquidada',
    class: 'badge-custom-liquidated'
  },
  
  // Azul Claro (#e6fdff / #00474d)
  paid: {
    backgroundColor: '#e6fdff',
    color: '#00474d',
    textColor: '#00474d',
    label: 'Pagada',
    class: 'badge-custom-paid'
  },
  
  // Rojo (#ffdede / #450000)
  rejected: {
    backgroundColor: '#ffdede',
    color: '#450000',
    textColor: '#450000',
    label: 'Rechazada',
    class: 'badge-custom-rejected'
  },
  
  // Gris (#e3e3e3 / #171717)
  annulled: {
    backgroundColor: '#e3e3e3',
    color: '#171717',
    textColor: '#171717',
    label: 'Anulada',
    class: 'badge-custom-annulled'
  }
};

// Estados para cobros (mantener compatibilidad)
export const COLLECTION_STATUSES = {
  pending: { 
    label: 'Pendiente', 
    class: 'badge-custom-pending',
    backgroundColor: '#fff3cd',
    textColor: '#856404'
  },
  processed: { 
    label: 'Procesado', 
    class: 'badge-custom-processed',
    backgroundColor: '#d2ffe8',
    textColor: '#00391c'
  },
  rejected: { 
    label: 'Rechazado', 
    class: 'badge-custom-rejected',
    backgroundColor: '#ffdede',
    textColor: '#450000'
  }
};

// Función helper para obtener la clase CSS de un estado
export const getStatusBadgeClass = (status, statusType = 'sale') => {
  const statusConfig = statusType === 'collection' ? COLLECTION_STATUSES : SALE_STATUS_CONFIG;
  return statusConfig[status]?.class || 'badge-custom-default';
};

// Función helper para obtener el label de un estado
export const getStatusLabel = (status, statusType = 'sale') => {
  const statusConfig = statusType === 'collection' ? COLLECTION_STATUSES : SALE_STATUS_CONFIG;
  return statusConfig[status]?.label || status;
};

// Función helper para obtener los colores de un estado
export const getStatusColors = (status, statusType = 'sale') => {
  const statusConfig = statusType === 'collection' ? COLLECTION_STATUSES : SALE_STATUS_CONFIG;
  return statusConfig[status] || { backgroundColor: '#e3e3e3', textColor: '#171717' };
};
